module.exports = __webpack_public_path__ + "static/media/Vector.a18b894b.svg";